import { useState, useEffect } from "react";

const useScreenSize = () => {
  const [width_screen, setWidth] = useState(window.innerWidth);
  const [height_screen, setHeight] = useState(window.innerHeight);

  useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleResize = () => {
    setWidth(window.innerWidth);
    setHeight(window.innerHeight);
  };

  return { height_screen, width_screen };
};

export default useScreenSize;
